var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"messengerArea"},[_c('div',{staticClass:"mt-5 fill-height"},[_c('div',{staticClass:"search"}),_c('div',{staticClass:"contactList"},[_c('ContactList')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }